import React, { useContext } from "react";
import { Button, ConfigContext, Scrollbar } from "@pionex-web-kit/components";
import { useTrackFn } from "@pionex-web-kit/common-business";
import { HelpCenterPage } from "./types";
import { useTranslators } from "../hooks/Locale";
import { ZendeskWidget } from "../ZendeskWidget/ZendeskWidget";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Questions = function Questions(_ref) {
  var type = _ref.type,
    category = _ref.category,
    list = _ref.list;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls("faq-question");
  var trackQuestionClick = useTrackFn(function (question) {
    return {
      key: "pionex_custom_service_click_question",
      data: {
        type: type,
        value1: question
      },
      platform: "ga"
    };
  });
  return /*#__PURE__*/_jsxs("div", {
    className: prefixCls,
    children: [!!category && /*#__PURE__*/_jsx("div", {
      className: "".concat(prefixCls, "-title"),
      children: category
    }), /*#__PURE__*/_jsx("ul", {
      className: "".concat(prefixCls, "-list"),
      children: list === null || list === void 0 ? void 0 : list.map(function (item, index) {
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx("a", {
            href: item.url,
            target: "_blank",
            onClick: function onClick() {
              trackQuestionClick(item.type);
            },
            children: item.label
          })
        }, "".concat(index));
      })
    })]
  });
};
export var Faq = function Faq(_ref2) {
  var navigate = _ref2.navigate,
    desc = _ref2.desc,
    _ref2$questions = _ref2.questions,
    questions = _ref2$questions === void 0 ? [] : _ref2$questions,
    close = _ref2.close;
  var _useContext2 = useContext(ConfigContext),
    getPrefixCls = _useContext2.getPrefixCls;
  var prefixCls = getPrefixCls("faq");
  var _useTranslators = useTranslators(),
    $st = _useTranslators.$st;
  var trackManualClick = useTrackFn(function () {
    return {
      key: "pionex_custom_service_click_manual",
      platform: "ga"
    };
  });
  return /*#__PURE__*/_jsxs("div", {
    className: prefixCls,
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(prefixCls, "-title-wrap"),
      children: /*#__PURE__*/_jsxs(Scrollbar, {
        style: {
          height: "100%"
        },
        children: [/*#__PURE__*/_jsx("div", {
          className: "".concat(prefixCls, "-title"),
          children: /*#__PURE__*/_jsx("div", {
            children: desc !== null && desc !== void 0 ? desc : $st("faq_desc")
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "".concat(prefixCls, "-question-wrap"),
          children: questions.map(function (item) {
            return /*#__PURE__*/_jsx(Questions, {
              type: item.type,
              category: item.category,
              list: item.list
            }, item.type);
          })
        }), /*#__PURE__*/_jsx("div", {
          style: {
            height: 40
          }
        })]
      })
    }), /*#__PURE__*/_jsx(Button, {
      size: "large",
      onClick: function onClick() {
        trackManualClick();
        if (ZendeskWidget.contact) {
          close === null || close === void 0 ? void 0 : close();
          ZendeskWidget.open();
        } else {
          if (ZendeskWidget.isLoginIn) {
            navigate(HelpCenterPage.contact);
          } else {
            navigate(HelpCenterPage.sign);
          }
        }
      },
      children: $st("customer_service_manual")
    })]
  });
};